import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Error = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM12 3.25C16.83 3.25 20.75 7.18 20.75 12C20.75 16.82 16.83 20.75 12 20.75C7.17 20.75 3.25 16.82 3.25 12C3.25 7.18 7.17 3.25 12 3.25ZM12 6.39001C11.66 6.39001 11.38 6.67001 11.38 7.01002V14.28C11.38 14.63 11.66 14.9 12 14.9C12.34 14.9 12.62 14.62 12.62 14.28V7.01002C12.62 6.66002 12.34 6.39001 12 6.39001ZM12.0001 18C12.5192 18 12.9401 17.5791 12.9401 17.06C12.9401 16.5408 12.5192 16.12 12.0001 16.12C11.4809 16.12 11.0601 16.5408 11.0601 17.06C11.0601 17.5791 11.4809 18 12.0001 18Z"
    />
  </svg>
)

export default withDefaultStyles(Error)
